export default __webpack_public_path__ + "locales/si/Common.json?hash=4e5f094c5eb5db3f74a3bdf6095b4ba3";